module.exports = __webpack_public_path__ + "img/do_not_copy_eir.52d20fa4.png";